import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { fetchFeaturedProducts } from '../../actions/shop'
import { URL_DISSENTER_SHOP } from '../../constants'
import PanelLayout from './panel_layout'
import ShopItem from '../shop_item'
import { shuffle } from 'lodash'
import Text from '../text'
import Icon from '../icon'
import VerifiedAccountIcon from '../verified_account_icon'

const features = [
  {
    title: 'Elevate Your Profile',
    subtitle: 'Showcase prime products, announce your business hours, and direct traffic to your website.',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" className={_s.fillPrimary} width="15px" height="15px" viewBox="0 0 24 24">
        <path className={_s.fillPrimary} d="M2,21H8a1,1,0,0,0,0-2H3.071A7.011,7.011,0,0,1,10,13a5.044,5.044,0,1,0-3.377-1.337A9.01,9.01,0,0,0,1,20,1,1,0,0,0,2,21ZM10,5A3,3,0,1,1,7,8,3,3,0,0,1,10,5ZM20.207,9.293a1,1,0,0,0-1.414,0l-6.25,6.25a1.011,1.011,0,0,0-.241.391l-1.25,3.75A1,1,0,0,0,12,21a1.014,1.014,0,0,0,.316-.051l3.75-1.25a1,1,0,0,0,.391-.242l6.25-6.25a1,1,0,0,0,0-1.414Zm-5,8.583-1.629.543.543-1.629L19.5,11.414,20.586,12.5Z"/>
      </svg>
    )
  },
  {
    title: 'Business Spotlight in Our Directory',
    subtitle: 'Stand alongside other thriving businesses in our curated directory.',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" className={_s.fillPrimary} width="15px" height="15px" viewBox="0 0 24 24">
        <path className={_s.fillPrimary} d="M5,7.087a3,3,0,0,0-3,3v3.826a3,3,0,0,0,2,2.816V21a1,1,0,0,0,1,1H9a1,1,0,0,0,1-1V17.423l10.609,4.5A1,1,0,0,0,22,21V3a1,1,0,0,0-1.391-.921L8.8,7.087ZM8,20H6V16.913H8Zm0-5.087H5a1,1,0,0,1-1-1V10.087a1,1,0,0,1,1-1H8Zm2-6.164L20,4.51V19.49L10,15.251Z"/>
      </svg>
    )
  },
  {
    title: 'Featured in Our Newsletters',
    subtitle: 'Reach millions as you get spotlighted in our wide-reaching newsletters.',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" className={_s.fillPrimary} width="15px" height="15px" viewBox="0 0 24 24">
        <path className={_s.fillPrimary} d="M21,3H3A2,2,0,0,0,1,5v7a2,2,0,0,0,2,2H21a2,2,0,0,0,2-2V5A2,2,0,0,0,21,3Zm0,9H3V5H21ZM5,10A1,1,0,0,1,6,9H18a1,1,0,0,1,0,2H6A1,1,0,0,1,5,10ZM16,7a1,1,0,0,1,1-1h1a1,1,0,0,1,0,2H17A1,1,0,0,1,16,7ZM9.793,20.293,11.086,19l-.293-.293a1,1,0,0,1,0-1.414l2-2a1,1,0,0,1,1.414,1.414L12.914,18l.293.293a1,1,0,0,1,0,1.414l-2,2a1,1,0,0,1-1.414-1.414Zm5.5,0L16.586,19l-.293-.293a1,1,0,0,1,0-1.414l2-2a1,1,0,0,1,1.414,1.414L18.414,18l.293.293a1,1,0,0,1,0,1.414l-2,2a1,1,0,0,1-1.414-1.414Zm-11,0L5.586,19l-.293-.293a1,1,0,0,1,0-1.414l2-2a1,1,0,0,1,1.414,1.414L7.414,18l.293.293a1,1,0,0,1,0,1.414l-2,2a1,1,0,0,1-1.414-1.414Z"/>
      </svg>
    )
  },
  {
    title: 'Your Business Success Partner',
    subtitle: "We're on this journey with you, let's thrive together!",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" className={_s.fillPrimary} width="15px" height="15px" viewBox="0 0 24 24">
        <path className={_s.fillPrimary} d="M22.424,3.094a1,1,0,0,0-1.065.138L16.144,7.579l-3.363-4.2a1.036,1.036,0,0,0-1.562,0l-3.363,4.2L2.64,3.232A1,1,0,0,0,1,4V18a3,3,0,0,0,3,3H20a3,3,0,0,0,3-3V4A1,1,0,0,0,22.424,3.094ZM21,18a1,1,0,0,1-1,1H4a1,1,0,0,1-1-1V17H21Zm0-3H3V6.135L7.36,9.768a1,1,0,0,0,1.421-.143L12,5.6l3.219,4.024a1,1,0,0,0,1.422.143L21,6.135Zm-6-3a1,1,0,0,1-1,1H10a1,1,0,0,1,0-2h4A1,1,0,0,1,15,12Z"/>
      </svg>
    )
  },
]

const pro_features = [
  {
    title: 'Gold Verification',
    subtitle: 'Flaunt your distinguished gold checkmark, establishing instant credibility.',
    icon: (<VerifiedAccountIcon size='40px' fill='#F1C62F' />),
  },
  {
    title: 'Monthly Advertising Bonus',
    subtitle: 'Each month, receive additional ad credits to further boost your presence on Gab Ads.',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" fill='#F1C62F' width="40px" height="40px" viewBox="0 0 24 24">
        <path d="M12,16a1,1,0,0,1-1-1V3a1,1,0,0,1,2,0V15A1,1,0,0,1,12,16ZM5,15V8A1,1,0,0,0,3,8v7a1,1,0,0,0,2,0Zm3-4a1,1,0,0,0-1,1v3a1,1,0,0,0,2,0V12A1,1,0,0,0,8,11Zm8-6a1,1,0,0,0-1,1v9a1,1,0,0,0,2,0V6A1,1,0,0,0,16,5Zm5,10V10a1,1,0,0,0-2,0v5a1,1,0,0,0,2,0ZM2,20v2H6V20L4,18Zm8,0v2h4V20l-2-2Zm8,0v2h4V20l-2-2Z"/>
      </svg>
    )
  },
  {
    title: 'Elevated Visibility',
    subtitle: "Get premium placements on Gab's marketplace, newsletters, and channels for increased brand visibility.",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" fill='#F1C62F' width="40px" height="40px" viewBox="0 0 24 24">
        <path d="M17,10.82l-3.09,1.644L15.09,17,12,14.13,8.91,17l1.18-4.536L7,10.82l3.82-.188L12,7l1.18,3.632ZM13,4V2a1,1,0,0,0-2,0V4a1,1,0,0,0,2,0ZM11,20v2a1,1,0,0,0,2,0V20a1,1,0,0,0-2,0ZM19.778,4.222a1,1,0,0,0-1.414,0L16.95,5.636A1,1,0,1,0,18.364,7.05l1.414-1.414A1,1,0,0,0,19.778,4.222ZM4.222,19.778a1,1,0,0,0,1.414,0L7.05,18.364A1,1,0,0,0,5.636,16.95L4.222,18.364A1,1,0,0,0,4.222,19.778ZM22,11H20a1,1,0,0,0,0,2h2a1,1,0,0,0,0-2ZM2,13H4a1,1,0,0,0,0-2H2a1,1,0,0,0,0,2Zm16.364,6.778a1,1,0,0,0,1.414-1.414L18.364,16.95a1,1,0,0,0-1.414,1.414ZM7.05,7.05a1,1,0,0,0,0-1.414L5.636,4.222A1,1,0,0,0,4.222,5.636L5.636,7.05a1,1,0,0,0,1.414,0Z"/>
      </svg>
    )
  },
  {
    title: 'Call-to-Actions',
    subtitle: 'Boost conversions with custom buttons on both your profile and listings, directing users to your products and website.',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" fill='#F1C62F' width="40px" height="40px" viewBox="0 0 24 24">
        <path d="M2.7,9.45a4.235,4.235,0,0,0,.3.3V22a1,1,0,0,0,1,1H20a1,1,0,0,0,1-1V9.752a4.235,4.235,0,0,0,.3-.3,4,4,0,0,0,.731-3.456L20.97,1.758A1,1,0,0,0,20,1H4a1,1,0,0,0-.97.758L1.972,5.994A4,4,0,0,0,2.7,9.45ZM13,21H11V16h2Zm6,0H15V15a1,1,0,0,0-1-1H10a1,1,0,0,0-1,1v6H5V10.9A3.989,3.989,0,0,0,8.914,9.61c.026.03.053.059.08.089A4.086,4.086,0,0,0,12.041,11a4.039,4.039,0,0,0,2.965-1.3c.027-.03.054-.059.08-.089A3.989,3.989,0,0,0,19,10.9ZM3.911,6.479,4.781,3H19.219l.87,3.479A2.029,2.029,0,0,1,18.12,9,2.041,2.041,0,0,1,16.1,7.14l-.042-.5a1,1,0,0,0-1.993.166v0a2.006,2.006,0,0,1-.529,1.539A2.059,2.059,0,0,1,11.959,9,2.029,2.029,0,0,1,9.937,6.806v0a1,1,0,0,0-.914-1.079.989.989,0,0,0-1.079.913l-.042.5A2.041,2.041,0,0,1,5.88,9,2.029,2.029,0,0,1,3.911,6.479Z"/>
      </svg>
      )
  }
]

class BusinessFeaturesPanel extends React.PureComponent {

  render() {
    const { noPanel, isThanks } = this.props

    const text = isThanks ? "Thank you for filling out the form. Your business is currently pending approval and will be reviewed shortly." : "Fill out the form below to have your business listed in our Parallel Economy directory."

    return (
      <PanelLayout
        noPanel={noPanel}
        noPadding={noPanel}
      >
        <div className={[_s.d, _s.w100PC, _s.pt5, _s.px10].join(' ')}>
          <Text>{text}</Text>
        </div>

        <div className={[_s.d, _s.w100PC, _s.pt15, _s.mt5, _s.px10].join(' ')}>
          <Text weight='bold' size='extraLarge'>Perks & Benefits</Text>
        </div>

        <div className={[_s.d, _s.flexRow, _s.flexWrap, _s.mt15].join(' ')}>
          {
            features.map((feature, i) => (
              <div className={[_s.d, _s.w100PC, _s.px2, _s.py2].join(' ')}>
                <div className={[_s.d, _s.aiStart, _s.w100PC, _s.px5, _s.py5, _s.bgSubtle_onHover, _s.radiusSmall].join(' ')}>
                  <Text weight='bold' size='medium'>
                    {feature.icon}&nbsp;&nbsp;
                    {feature.title}
                  </Text>
                  <Text color='secondary' className={_s.pt2}>{feature.subtitle}</Text>
                </div>
              </div>
            ))
          }
        </div>
 
      </PanelLayout>
    )
  }
}

export default BusinessFeaturesPanel